// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeOtpVerifyBody = {
  requestId: string;
  code: string;
};

export type typeOtpVerifyOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    accessToken: string;
    refreshToken: string;
    expiresInSeconds: number;
    user: { userId: string; email: string; isSuperAdmin: boolean };
  };
};

export type typeOtpVerifyOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOtpVerifyOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOtpVerifyOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaOtpVerifyBody = {
  type: "object",
  properties: {
    requestId: { type: "string", maxLength: 3000, minLength: 1 },
    code: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["requestId", "code"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createOtpVerify(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaOtpVerifyBody);
  }

  return async function postOtpVerify(
    payload: typeOtpVerifyBody,
  ): Promise<typeOtpVerifyOutput200 | typeOtpVerifyOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postOtpVerify" failed before calling the network. #beefefe941f8`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#beefefe941f8" },
        },
        data: null,
      } as typeOtpVerifyOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/otp/verify`,
      httpMethod: "POST",
      options,
    })) as typeOtpVerifyOutput200 | typeOtpVerifyOutput400;
  };
}
